<template>
  <div class="upload-container">
    <ImageThumbnail 
      v-if="imageURL" 
      :url="imageURL" 
      :max-width="props.maxWidth"
      :max-height="props.maxHeight"
    />
    <button v-if="imageURL" class="action-button delete" @click="handleDelete">
      <font-awesome-icon icon="trash" />
    </button>
    <FileUpload
      v-else
      :max-file-size="props.maxFileSize"
      :req-file-width="props.reqFileWidth"
      :req-file-height="props.reqFileHeight"
      accept="image/*"
      :folder="props.folder"
      @success="handleUploadSuccess"
    />
  </div>
</template>

<script setup>
import { defineModel } from 'vue';
import FileUpload from './FileUpload.vue';
import ImageThumbnail from './ImageThumbnail.vue';

const imageURL = defineModel({ type: String });

const props = defineProps({
  folder: {
    type: String,
    required: true
  },
  maxWidth: {
    type: String,
    default: ''
  },
  maxHeight: {
    type: String,
    default: ''
  },
  maxFileSize: {
    type: Number,
    default: 5 * 1024 * 1024 // 5MB
  },
  reqFileWidth: {
    type: Number,
    default: 0
  },
  reqFileHeight: {
    type: Number,
    default: 0
  }
});

const handleUploadSuccess = (fileData) => {
  imageURL.value = fileData.url;
};

const handleDelete = () => {
  imageURL.value = '';
};
</script>

<style scoped>
@import '@/styles/file-upload.css';
</style>
